<div class="hero-section">
  <div class="hero-section__container" >
    <div class="hero-section__description">
      <div class="hero-section__logo-holder">
        <img *ngIf="isProductLogo" class="hero-section__logo" [src]="logoPath">
      </div>
        <h1  [innerHTML]="header" l10nTranslate></h1>
        <p  [innerHTML]="description" l10nTranslate>

        </p>
        <div class="hero-section__btn_holder">
          <button *ngIf="hasBtn" class="hero-section__btn" [routerLink]="[routerButton]" l10nTranslate>{{buttonText}}</button>
          <a *ngIf="isProductGRCPage" class="hero-section__btn-data-sheet" target="_blank" href="https://solidrangebrochures.s3.amazonaws.com/Easycompliance+GRC+Platform+AR+-+Data+Sheet+v2+1.pdf">Data Sheet</a>
        <div class="hero-section-ksa-img" *ngIf="isKsaImg">
          <img src="../../../../assets/svg/Layer_1.svg">
      </div>
        </div>
        
    </div>

    <div class="hero-section__background">
        <img [src]="imagePath" alt="hero-section" >
    </div>


  </div>
</div>
